module.exports = __webpack_public_path__ + "static/media/006.516579cb.jpg";